// Web Audio alarm for the operations center. No asset needed.
let ctx = null;

export function unlockAudio() {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    g.gain.value = 0.0001;
    o.connect(g);
    g.connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.02);
    return true;
  } catch (e) {
    return false;
  }
}

export function playAlarm() {
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
  const now = ctx.currentTime;
  const beeps = [0, 0.35, 0.7];
  beeps.forEach((offset, i) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "square";
    o.frequency.setValueAtTime(i % 2 === 0 ? 880 : 660, now + offset);
    g.gain.setValueAtTime(0.0001, now + offset);
    g.gain.exponentialRampToValueAtTime(0.28, now + offset + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + offset + 0.3);
    o.connect(g);
    g.connect(ctx.destination);
    o.start(now + offset);
    o.stop(now + offset + 0.32);
  });
}
